/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import store from '@/store';
import platform from '@/shared/utils/platform';
import { env } from '@/constant';
import { landData } from '@/shared/utils/landData';
import { Vue } from 'vue/types/vue';
import { Route } from 'vue-router';
import { AUTARKY_UPGRADE_PROCESS_STATE } from '@/views_v2/home/const';
import isPrerendering from '../isPrerendering';

// 处理fat_开头的环境，统一上报到fat，以保证fat埋点验证，在非主入口的地方也可以通过离线验证来验收埋点
const ubtEnv = env.startsWith('fat_') ? 'fat' : env;

// 预渲染不需要采集埋点数据
const { UBT } = (window as any).TianQi;
const { UBT: APM } = (window as any).TianQiApm;
const shouldSendUBT = UBT && !isPrerendering();
const isDevelopment = process.env.NODE_ENV === 'development';
// 错误上报（本地开发环境无需上报）
const shouldSendAPM = APM && !isPrerendering() && !isDevelopment;
const versionMatch = /version=([\d.]*)/.exec(navigator.userAgent);
const appVersion = versionMatch && versionMatch[1];
const appName = 'AppFinanceH5Web';
const url = window.location.href;
const getBaseStore = () => store?.state?.base || ({
  originUserInfo: {},
  deviceInfo: {},
  cityInfo: {},
});

/** 根据用户状态改变当前page_id值
 * 用于区分自营用户和 其他普通用户
 * 自营用户升级阶段，page_id取升级的page_id，升级完成后变为普通用户，page_id回置
 */
export const getPageIdByUser = (
  to:Route,
  routerMeta:Dictionary<string>,
):string => {
  const { autarkyState } = store.state.home || {};
  if (autarkyState
    && autarkyState.autarky) {
    if (autarkyState.autarkyUpgradeState
      && AUTARKY_UPGRADE_PROCESS_STATE.includes(autarkyState.autarkyUpgradeState)
      && routerMeta.upgradePageId
    ) {
      /** 老客升级页面的PageId，是route品质首页的埋点上报(小程序无老客升级) */
      to.meta.pageId = routerMeta.upgradePageId;
      return routerMeta.upgradePageId;
    }
  }
  to.meta.pageId = routerMeta.pageId;
  return routerMeta.pageId;
};

// APM SDK 业务接入文档：https://hellobike.yuque.com/gzxsb9/gdvwvw/itybxd#3XBHj
const bindData = {
  appVersion,
  appName,
  platform: platform.name,
  url,
  os: () => {
    if (platform.isAndroid) {
      return 'Android';
    }

    if (platform.isHarmony) {
      return 'Harmony';
    }

    return platform.isIOS ? 'iOS' : 'other';
  },
  // APP运行的网络环境，2G，3G，4G，WIFI
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  network: navigator.connection && navigator.connection.type,
  screenHeight: window.screen.height,
  screenWidth: window.screen.width,
  userGuid: () => getBaseStore().originUserInfo.userGuid || '',
  // 增加userNewId 传输，供实时营销事件使用
  userNewId: () => getBaseStore().originUserInfo.userNewId || '',
  cityCode: () => (getBaseStore().cityInfo as NativeModel.CityInfo).cityCode || '',
  cityName: () => (getBaseStore().cityInfo as NativeModel.CityInfo).cityName || '',
  adCode: () => (getBaseStore().cityInfo as NativeModel.CityInfo).adCode
    || (getBaseStore().cityInfo as NativeModel.AliCityInfo).cityAdcode
    || '',
  longitude: () => getBaseStore().cityInfo.longitude || '',
  latitude: () => getBaseStore().cityInfo.latitude || '',
  // 设备品牌
  manufacturer: () => getBaseStore().deviceInfo.manufacturer || '',
  // 设备类型
  deviceModel: () => getBaseStore().deviceInfo.deviceModel || '',
  version: () => getBaseStore().deviceInfo.appVersion || '',
  osVersion: () => getBaseStore().deviceInfo.osVersion || '',
  // 监听pageload回调
  pageloadCallback: () => {
    // 上报callBack错误触发
    const { callBackErrorList, TianQiApm } = window;
    if (callBackErrorList && callBackErrorList.length > 0) {
      callBackErrorList.forEach((item) => {
        if (typeof TianQiApm.UBT.sendError === 'function') {
          TianQiApm.UBT.sendError(item);
        }
      });
      window.callBackErrorList = [];
    }
  },
};

if (shouldSendUBT) {
  UBT.config({
    // 自定义环境上传到fat
    env: ubtEnv,
    debug: false,
    categoryId: 'finance',
    logMaxCount: 1,
  });

  UBT.bindData(bindData);
}

if (shouldSendAPM) {
  APM.config({
    // 自定义环境上传到fat
    env: ubtEnv,
    debug: false,
    categoryId: 'finance',
    logMaxCount: 1,
  });
  APM.bindData(bindData);
}

// 获取业务参数 并 可以设置自定义参数
const getBusinessInfo = (customParams: Dictionary) => ({
  $screen_height: String(window.screen.height),
  $screen_width: String(window.screen.width),
  $browser: navigator.userAgent,
  $browser_version: navigator.appVersion,
  additionType: '来源',
  additionValue: landData.getSouce(),
  token: store.state.base.originUserInfo.userGuid,
  $device_id:
    store.state.base.deviceInfo.idfa || store.state.base.deviceInfo.imei || '',
  $manufacturer: store.state.base.deviceInfo.manufacturer,
  h5uuid: store.state.base.h5UUids || '',
  platform: platform.currentPlatformType.platform,
  ...customParams,
});


export const ubtButton = (
  pageId: string,
  buttonName: string,
  flagType?: string,
  flagValue?: number | string,
  extraType?: string,
  extraValue?: number | string,
  differType?: string,
  differValue?: number | string,
): void => {
  if (shouldSendUBT) {
    const ubtButtonData = {
      pageId,
      buttonName,
      categoryId: 'finance',
      businessInfo: getBusinessInfo({
        clickTime: new Date().getTime(),
        flagType,
        flagValue,
        extraType,
        extraValue,
        differType,
        differValue:
          typeof differValue === 'object'
            ? JSON.stringify(differValue)
            : differValue,
      }),
    };
    UBT.clickButton(ubtButtonData);
  }
};

export const ubtButtonNew = (
  pageId: string,
  buttonName: string,
  otherProps: Dictionary = {},
): void => {
  if (shouldSendUBT) {
    const ubtNewButtonData = {
      pageId,
      buttonName,
      categoryId: 'finance',
      businessInfo: getBusinessInfo({
        clickTime: new Date().getTime(),
        ...otherProps,
        source: landData.getSouce(),
      }),
    };
    UBT.clickButton(ubtNewButtonData);
  }
};

export const ubtPage = (
  pageId: string,
  fromPage: string,
  inTime: number,
  outTime?: number,
  extra?: {
    flagType?: string;
    flagValue?: number | string;
    extraType?: string;
    extraValue?: number | string;
    differType?: string;
    differValue?: number | string;
  } & Dictionary,
): void => {
  if (shouldSendUBT) {
    const ubtPageViewData = {
      pageId,
      categoryId: 'finance',
      businessInfo: getBusinessInfo({
        fromPage,
        pageId,
        inTime,
        outTime,
        ...(extra || Object.create(null)),
      }),
    };
    UBT.pageView(ubtPageViewData);
  }
};

export const ubtPageViewOut = (
  pageId: string,
  fromPage: string,
  inTime: number,
  outTime?: number,
  extra?: {
    flagType?: string;
    flagValue?: number | string;
    extraType?: string;
    extraValue?: number | string;
    differType?: string;
    differValue?: number | string;
  },
): void => {
  if (shouldSendUBT) {
    UBT.pageViewOut({
      pageId,
      categoryId: 'finance',
      businessInfo: getBusinessInfo({
        fromPage,
        pageId,
        inTime,
        outTime,
        ...(extra || Object.create(null)),
      }),
    });
  }
};

// 曝光事件
export const moduleExpose = (
  pageId: string,
  moduleId: string,
  flagType?: string,
  flagValue?: number | string,
  extraType?: string,
  extraValue?: number | string,
  differType?: string,
  differValue?: number | string,
  otherType?: string,
  otherValue?: string,
): void => {
  let extraParams = {
    clickTime: new Date().getTime(),
    flagType,
    flagValue,
    extraType,
    extraValue,
    differType,
    differValue:
          typeof differValue === 'object'
            ? JSON.stringify(differValue)
            : differValue,
  };
  if (otherType && otherValue) {
    extraParams = Object.assign(extraParams, { [otherType]: otherValue });
  }
  if (shouldSendUBT) {
    const ubtExposeData = {
      // 是曝光内容所在的页面 必填
      pageId,
      // 对应曝光的页面区块标识 必填
      moduleId,
      // 对应页面区块的内容标识 必填
      contentId: moduleId,
      // 业务 ID
      categoryId: 'finance',
      // 内容曝光次数 必填
      exposureTimes: '1',
      businessInfo: getBusinessInfo(extraParams),
    };
    UBT.moduleExpose(ubtExposeData);
  }
};

export function ubtPageButton(
  that: Vue,
  buttonName: string,
  flagType?: string,
  flagValue?: number | string,
  extraType?: string,
  extraValue?: number | string,
  differType?: string,
  differValue?: number | string,
): void {
  ubtButton(
    that.$route.meta.pageId,
    buttonName,
    flagType,
    flagValue,
    extraType,
    extraValue,
    differType,
    differValue,
  );
}

export function ubtPageButtonNew(
  that: Vue | string,
  buttonName: string,
  otherProps:Dictionary,
): void {
  const pageId = typeof that === 'string' ? that : (that.$route && that.$route.meta.pageId);
  ubtButtonNew(
    pageId,
    buttonName,
    otherProps,
  );
}

export function ubtModuleExposeNew(
  that: Vue | string,
  moduleId: string,
  otherProps: Dictionary = {},
):void {
  const pageId = typeof that === 'string' ? that : (that.$route && that.$route.meta.pageId);
  const ubtExposeData = {
    // 是曝光内容所在的页面 必填
    pageId,
    // 对应曝光的页面区块标识 必填
    moduleId,
    // 对应页面区块的内容标识 必填
    contentId: moduleId,
    // 业务 ID
    categoryId: 'finance',
    // 内容曝光次数 必填
    exposureTimes: '1',
    businessInfo: getBusinessInfo({
      ...otherProps,
      source: landData.getSouce(),
    }),
  };
  UBT.moduleExpose(ubtExposeData);
}

export function ubtModuleExpose(
  that: Vue,
  buttonName: string,
  flagType?: string,
  flagValue?: number | string,
  extraType?: string,
  extraValue?: number | string,
  differType?: string,
  differValue?: number | string,
  otherType?: string,
  otherValue?: string,
): void {
  moduleExpose(
    that.$route.meta.pageId,
    buttonName,
    flagType,
    flagValue,
    extraType,
    extraValue,
    differType,
    differValue,
    otherType,
    otherValue,
  );
}

/**
 * 主动上报异常:（js内部异常、jsb异常、服务接口异常）
 * @param error
 */
export function ubtSendError(
  error: Error | string | { name: string, message: string, stack: string },
): void {
  if (typeof APM.sendError === 'function') {
    /** 自定义对象 需转换成 Error对象，否则无法上报成功 */
    if (error instanceof Error === false && typeof error === 'object') {
      const { name } = error || {};
      APM.sendError(Object.assign(new Error(name), error));
    } else {
      APM.sendError(error);
    }
  }
}

/**
 * 自定义行为埋点
 * @param customPointId string 自定义埋点ID
 * @param extraParams ExtraParams 额外的埋点业务参数
 */
export const ubtCustomEvent = (
  that: Vue | string,
  customPointId: string,
  extraParams: Dictionary<unknown> = {},
): void => {
  const pageId = typeof that === 'string' ? that : (that.$route && that.$route.meta.pageId);

  UBT.customEventWithPointId({
    pageId,
    /** 自定义埋点ID */
    pointId: customPointId,
    // 业务 ID
    categoryId: 'finance',
    businessInfo: getBusinessInfo({
      clickTime: new Date().getTime(),
      ...extraParams,
    }),
  });
};
